import React from 'react'
import TextField from 'react-mobx-admin/components/common/field/text'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import SelectInput from '../../input/select'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import RegionsInput from '../../input/regions'
import EmbededEntityInput from '../../input/embedded_entity'

const VideoIDSEdit = ({store, ...rest}) => {
  const _EditForm = ({record, updateFormField, errors}) => {
    return (
      <div className='row'>
        <div className='col-xs-12'>
          <SelectInput label={store.__('video id')}
            attr={'name'} record={record}
            onChange={updateFormField} optionsrecord={store.options}
            optionsattr={'VideoId'}
            labelattr='text' valueattr='value' errors={errors} />
          <RegionsInput
            label={store.__('regions')}
            attr={'country'}
            record={record}
            onChange={updateFormField}
            optionsrecord={store.options}
            optionsattr={'Countries'}
            errors={errors} />
          <TextInput
            label={store.__('value')}
            attr={'value'}
            record={record}
            onChange={updateFormField}
            errors={errors} />
        </div>
      </div>
    )
  }

  const idVals = store.options.get('VideoId').map((i) => i.value)
  const filter = (i) => {
    return idVals.indexOf(i.name) >= 0
  }

  return (
    <EmbededEntityInput
      store={store}
      attr={'videoids'}
      edit_title={store.__('edit video IDs item')}
      add_title={store.__('add video IDs item')}
      items={store.cv.record.get('attributes_regional')}
      filter={filter}
      fields={[
        (attr, row) => (<OptionsField
          attr={attr}
          val={row[attr]}
          options={store.options.get('VideoId')}
          labelattr='text'
          valueattr='value' />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />)
      ]}
      rowId={(row) => (row.person_id)}
      EditForm={_EditForm} {...rest}
    />
  )
}

export default VideoIDSEdit
